{
	"title": "Details for cycle #{{cycleNumber}}",
	"backToPageLabel": "Assure carbon reductions"
}
